export const extractTransformValues = cssString => {
    // 正则表达式匹配 width 和 height 的值
    const widthRegex = /width:\s*(-?\d+\.?\d*)px;/;
    const heightRegex = /height:\s*(-?\d+\.?\d*)px;/;

    // 正则表达式匹配 translate 的值
    const translateRegex = /translate\((-?\d+\.?\d*)px,\s*(-?\d+\.?\d*)px\)/;

    // 正则表达式匹配 rotate 的值
    const rotateRegex = /rotate\((-?\d+\.?\d*)deg\)/;

    // 正则表达式匹配clip-path 的值
    const clipRegex = /clip-path:\s*([^;]+);/;

    // 提取 width 和 height
    const widthMatches = widthRegex.exec(cssString);
    const heightMatches = heightRegex.exec(cssString);

    // 提取 translate
    const translateMatches = translateRegex.exec(cssString);

    // 提取 rotate
    const rotateMatches = rotateRegex.exec(cssString);

    // 提取 clip-path
    const clipMatches = clipRegex.exec(cssString);

    const result = {
        width: widthMatches ? parseFloat(widthMatches[1]) : 0,
        height: heightMatches ? parseFloat(heightMatches[1]) : 0,
        translate: translateMatches
            ? {x: parseFloat(translateMatches[1]), y: parseFloat(translateMatches[2])} : {x: 0, y: 0},
        rotate: rotateMatches ? parseFloat(rotateMatches[1]) : 0,
        clipPath: clipMatches ? clipMatches[1] : 'inset(0%)'
    };

    return result;
};


export const extractClipPath = cssString => {
    const insetRegex = /inset\((\d+(?:\.\d+)?%?)\s*(\d+(?:\.\d+)?%?)?\s*(\d+(?:\.\d+)?%?)?\s*(\d+(?:\.\d+)?%?)?\)/;

    const convertToNumber = value => {
        if (!value) {
            return 0;
        } // 如果值不存在，则返回null
        return parseFloat(value);
    };

    // 解析并转换每个inset值
    const matches = cssString.match(insetRegex);
    if (matches) {
        const top = convertToNumber(matches[1]);
        const right = convertToNumber(matches[2] || matches[1]); // 如果右边值不存在，使用上边的值
        const bottom = convertToNumber(matches[3] || matches[1]); // 如果下边值不存在，使用上边的值
        const left = convertToNumber(matches[4] || matches[2] || matches[1]); // 如果左边值不存在，使用右边或上边的值
        return {top, right, bottom, left};
    }
    return {top: 0, right: 0, bottom: 0, left: 0};
};

export const extractIntegers = (str) => {
    if (typeof str === 'number') {
        return [str];
    }
    // 使用正则表达式匹配所有的数字，包括带有正负号的整数
    const regex = /-?\d+/g;
    // 使用match方法获取所有的匹配项
    const matches = str?.match(regex);
    // 如果没有匹配到任何数字，返回一个空数组
    if (!matches) {
        return [];
    }
    // 将匹配到的字符串数字转换为整数
    const integers = matches.map(num => parseInt(num, 10));
    return integers;
};

export const parseTextShadow = (textShadow) => {
    // 定义一个正则表达式来匹配 textShadow 中的颜色和数字值
    // 正则表达式解释：
    // (\S+) 匹配非空字符序列（颜色值）
    // ([\d.]+)px 匹配数字（可能带有小数点）后跟 'px'（X偏移）
    // ([\d.]+)px 匹配数字（可能带有小数点）后跟 'px'（Y偏移）
    // ([\d.]+)px? 匹配数字（可能带有小数点）后跟可选的 'px'（模糊半径）
    const regex = /(rgba?\([^)]+\)|\S+) ([\d.-]+)px ([\d.-]+)px ([\d.-]+)px?/;
    const matches = textShadow?.match(regex);

    if (!matches) {
        // 如果没有匹配到，说明格式不符合预期，可以抛出错误或返回 null
        return {};
    }

    // 提取颜色和数字值，转换为期望的格式
    const [, color, offsetX, offsetY, blur] = matches;
    return {
        color: color || 'transparent',
        offsetX: parseFloat(offsetX) || 0,
        offsetY: parseFloat(offsetY) || 0,
        blur: parseFloat(blur) || 0
    };
};